import { render, staticRenderFns } from "./clinical.vue?vue&type=template&id=0cf1d6ff&scoped=true"
import script from "./clinical.vue?vue&type=script&lang=js"
export * from "./clinical.vue?vue&type=script&lang=js"
import style0 from "./clinical.vue?vue&type=style&index=0&id=0cf1d6ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf1d6ff",
  null
  
)

export default component.exports